module.exports = __webpack_public_path__ + "static/media/backlight7.ec8f5a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight7.jpg
// module id = 318
// module chunks = 0